export default __webpack_public_path__ + "static/media/activateLogoWhite.19ee406a.png";